import { userIntentValues } from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';
import { z } from 'zod';

const userIntent = Object.values(userIntentValues);

export const ClientIntentSchema = z.object({
  userIntent: z.enum(ZodArrayToEnum(userIntent)),
});

export type ClientIntentForm = z.infer<typeof ClientIntentSchema>;
